/**
 * Returns the gas value plus a margin for unexpected or variable gas costs
 * @param value the gas value to pad
 * @returns The padded gas value as a native bigint.
 */
export function calculateGasMargin(value: bigint): bigint {
  // Gas margin calculation: value * 1.2, using BigInt integer math
  // (value * 120) / 100
  return (value * 120n) / 100n
}
